import { createAction } from "@reduxjs/toolkit";
import { TalesFaq } from "../../../utils/types/TalesFaq";

export const setFaqData = createAction<TalesFaq[]>("faq/setData");
